import React from 'react';
export default function RadioInput(_ref) {
  var identifier = _ref.identifier,
    options = _ref.options,
    currentOption = _ref.currentOption,
    setCurrentOption = _ref.setCurrentOption;
  var identifierKey = identifier || 'key';
  return /*#__PURE__*/React.createElement(React.Fragment, null, options.map(function (option) {
    var isCurrent = option[identifierKey] === currentOption;
    return /*#__PURE__*/React.createElement("div", {
      key: option.key,
      className: "radio-input flex-box items-center",
      onClick: function onClick() {
        return setCurrentOption(option);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "radio ".concat(isCurrent ? 'selected' : '', " flex-box items-center content-center")
    }, isCurrent && /*#__PURE__*/React.createElement("div", {
      className: "radio-filler"
    })), /*#__PURE__*/React.createElement("div", {
      className: "radio-option ".concat(isCurrent ? 'selected' : '')
    }, option.itemRenderer ? option.itemRenderer(option) : option.title));
  }));
}